module.exports = __webpack_public_path__ + "static/media/laporan_displiner.21571ff1.png";